import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Dialog } from '../../../../common/components/Dialog/Dialog';
import Button from '../../../../common/components/Button/Button';

function TokenExpireDialog({ logout, stay, clearTimeout, isFetching, sessionExpireDialog }) {
  useEffect(() => {
    window.onbeforeunload = clearTimeout();
    window.unload = clearTimeout();
  }, []);

  const actions = [
    <Button key="no-btn" color="secondary" disabled={isFetching} onClick={logout}>
      No
    </Button>,
    <Button key="yes-btn" disabled={isFetching} onClick={stay}>
      Yes
    </Button>,
  ];

  return (
    <Dialog actions={actions} modal open={sessionExpireDialog}>
      <div className="confirmation-dialog-text">Your session is expiring soon. Would you like to stay logged in?</div>
    </Dialog>
  );
}

TokenExpireDialog.propTypes = {
  logout: PropTypes.func,
  stay: PropTypes.func,
  clearTimeout: PropTypes.func,
  isFetching: PropTypes.bool,
  sessionExpireDialog: PropTypes.bool,
};

export default TokenExpireDialog;
